var PainScaleIconType;
(function (PainScaleIconType) {
    PainScaleIconType["INTENSE_PAIN"] = "IntensePain";
    PainScaleIconType["MILD_PAIN"] = "MildPain";
    PainScaleIconType["MODERATE_PAIN"] = "ModeratePain";
    PainScaleIconType["PAINLESS"] = "Painless";
    PainScaleIconType["UNBEARABLE_PAIN"] = "UnbearablePain";
})(PainScaleIconType || (PainScaleIconType = {}));
var PainScaleType;
(function (PainScaleType) {
    PainScaleType["VISUAL_REP_COMPLEX"] = "visual-representation-complex";
    PainScaleType["VISUAL_REP_SIMPLE"] = "visual-representation-simple";
    PainScaleType["VISUAL_REP_LIGHT"] = "visual-representation-light";
})(PainScaleType || (PainScaleType = {}));
export { PainScaleIconType, PainScaleType, };
//# sourceMappingURL=pain-scale-type.js.map